import { createActionGroup, props } from '@ngrx/store';
import { LoadPropertyNotesActionParams } from '../../models/property.model';
import { GetNotesResponseModel } from '../../../shared/models/properties/properties.models';

interface LoadPropertyNotesFailurePayload {
  error: unknown;
}

export const PropertyNotesActions = createActionGroup({
  source: 'PROPERTY',
  events: {
    'Load Property Notes': props<LoadPropertyNotesActionParams>(),
    'Load Property Notes Success': props<GetNotesResponseModel>(),
    'Load Property Notes Failure': props<LoadPropertyNotesFailurePayload>(),
  },
});
